<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ retailCoupon.couponTitle }}
            </h1>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="6"
        cols="12"
      >
        <b-button
          v-if="canViewThisAction('update', 'RetailCoupon')"
          variant="flat-primary"
          :to="{ name: 'products-retail-coupons-edit', params: { id: $route.params.id } }"
        >
          <feather-icon
            icon="EditIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle">Edit</span>
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-card
          header="Retail Coupon Details"
          header-tag="header"
        >
          <template #header>
            <b-button
              type="button"
              variant="flat-primary"
              class="primary-button-with-background mr-3"
            >
              <feather-icon
                icon="GridIcon"
                class=""
                size="20"
              />
            </b-button>
            <h3 class="align-middle mr-auto">
              Retail Coupon Details
            </h3>
          </template>
          <b-table-simple
            borderless
            responsive
            class="custom-th-width"
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  Coupon Code
                </b-th>
                <b-td class="mt-50">
                  {{ retailCoupon.couponCode || '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Coupon Title
                </b-th>
                <b-td class="mt-50">
                  {{ retailCoupon.couponTitle || '-' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Value
                </b-th>
                <b-td class="mt-50">
                  {{ valueText }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Usable From
                </b-th>
                <b-td class="mt-50">
                  {{ retailCoupon.usableFrom ? dateFormat(retailCoupon.usableFrom) : 'Usable from now' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Usable Until
                </b-th>
                <b-td class="mt-50">
                  {{ retailCoupon.usableUntil ? dateFormat(retailCoupon.usableUntil) : 'Usable forever' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Status
                </b-th>
                <b-td class="mt-50">
                  <b-badge
                    :variant="`light-${resolveStatusVariant(retailCoupon.status)}`"
                    class="text-capitalize"
                  >
                    {{ retailCoupon.status }}
                  </b-badge>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-card
          header="Quota &amp; Redemptions"
          header-tag="header"
        >
          <template #header>
            <b-button
              type="button"
              variant="flat-primary"
              class="primary-button-with-background mr-3"
            >
              <feather-icon
                icon="GridIcon"
                class=""
                size="20"
              />
            </b-button>
            <h3 class="align-middle mr-auto">
              Quota &amp; Redemptions
            </h3>
          </template>
          <b-table-simple
            borderless
            responsive
            class="custom-th-width"
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  Quota per User
                </b-th>
                <b-td class="mt-50">
                  {{ retailCoupon.quotaPerUser != null ? retailCoupon.quotaPerUser : 'No limit' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Total Quota
                </b-th>
                <b-td class="mt-50">
                  {{ retailCoupon.totalQuota != null ? retailCoupon.totalQuota : 'No limit' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Used Quota
                </b-th>
                <b-td class="mt-50">
                  {{ retailCoupon.usedQuota != null ? retailCoupon.usedQuota : 0 }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>

          <b-table-simple
            v-if="redeemedBy.length"
            responsive
            class="mt-2"
          >
            <b-thead>
              <b-tr>
                <b-th>Redeemed By</b-th>
                <b-th>Redeemed At</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr
                v-for="(entry, index) in redeemedBy"
                :key="index"
              >
                <b-td>{{ entry.email || '-' }}</b-td>
                <b-td>{{ entry.redeemedAt ? dateFormatWithTime(entry.redeemedAt) : '-' }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <p
            v-else
            class="text-muted mb-0"
          >
            This coupon has not been redeemed yet.
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTableSimple, BThead, BTbody, BTr, BTd, BTh, BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BThead,
    BTbody,
    BTh,
    BTr,
    BTd,
    BBadge,
  },
  data() {
    return {
      retailCoupon: {},
    }
  },
  computed: {
    redeemedBy() {
      return this.retailCoupon.redeemedBy || []
    },
    valueText() {
      if (this.retailCoupon.valueType === 'Percentage') {
        return `${this.retailCoupon.value}%`
      }
      if (this.retailCoupon.valueType === 'Dollar') {
        return `$${this.numberFormat(this.retailCoupon.value)}`
      }
      return '-'
    },
  },
  mounted() {
    this.$http.get(`products/retail-coupons/${this.$route.params.id}/show`)
      .then(response => {
        this.retailCoupon = response.data.data

        this.$store.commit('breadcrumb/REMOVE_BREADCRUMB')
        const newMeta = {
          active: true,
          text: this.retailCoupon.couponTitle,
        }
        this.$store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  setup() {
    const { canViewThisAction } = useAclUtils()

    return {
      canViewThisAction,
    }
  },
  methods: {
    resolveStatusVariant(status) {
      if (status === 'Active') return 'success'
      if (status === 'Inactive') return 'secondary'
      return 'primary'
    },
  },
}
</script>

<style lang="scss">
  .custom-th-width {
    .table th {
        padding: 0.72rem 2rem 0.72rem 0.72rem;
    }
  }
</style>
